import {Box} from "../../../customer/customerAccountingPage/customerAccountingRow/CustomerAccountingRow.styles";
import React from "react";
import {Tooltip} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";

export const FilterButton = ({
    label,
    amount,
    topAmount,
    bottomAmount,
    topInfo,
    bottomInfo,
    icon,
    handleClick,
    isActive
}) => {
    return (
        <Box
            onClick={handleClick}
            isActive={isActive}
            style={{
                minWidth: 180,
                maxWidth: 220,
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px 8px"
            }}
        >
            {icon}
            {/* <img src={icon} alt="load credit icon" /> */}
            <b style={{marginBottom: 4, textAlign: "center"}}>{label}</b>
            {topAmount && bottomAmount ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "4px",
                        minWidth: 90,
                        maxWidth: 180,
                        minHeight: 48,
                        justifyContent: "center",
                        overflow: "hidden",
                        wordBreak: "break-word",
                        textAlign: "center"
                    }}
                >
                    <b style={{fontSize: 15, lineHeight: 1.1, wordBreak: "break-word"}}>
                        {topAmount}
                        {topInfo ? (
                            <Tooltip title={topInfo}>
                                <InfoCircleOutlined style={{marginLeft: "4px"}} />
                            </Tooltip>
                        ) : (
                            <> </>
                        )}
                    </b>
                    <div
                        style={{
                            width: "80%",
                            height: "1px",
                            backgroundColor: "#d9d9d9",
                            margin: "2px 0"
                        }}
                    />
                    <span style={{fontSize: 12, lineHeight: 1.1, wordBreak: "break-word"}}>
                        {bottomAmount}
                        {bottomInfo ? (
                            <Tooltip title={bottomInfo}>
                                <InfoCircleOutlined style={{marginLeft: "4px"}} />
                            </Tooltip>
                        ) : (
                            <> </>
                        )}
                    </span>
                </div>
            ) : (
                <div
                    style={{
                        minHeight: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%"
                    }}
                >
                    <b style={{fontSize: 16, wordBreak: "break-word", textAlign: "center"}}>
                        {amount}
                    </b>
                </div>
            )}
        </Box>
    );
};
